// Phase 129 Plan 04 Task 1 — Homepage composition.
//
// Renders nav + hero + demo section. The demo section subscribes to web-api
// over Socket.IO; on the first inbound it transitions from the short-code
// card to the chat panel.
import { Nav } from '../components/nav';
import { Hero } from '../components/hero';
import { BuiltFor } from '../components/built-for';
import { DemoSection } from '../components/demo/demo-section';
import { Pricing } from '../components/pricing';
import { FinalCta } from '../components/final-cta';

// AIT-268 — self-canonical for the homepage. Must live here, not in root.tsx:
// route links() exports aggregate, so a root-level canonical would apply
// itself to /whatsapp, /instagram, /affiliates and every other route.
export function links() {
  return [{ rel: 'canonical', href: 'https://hookmyapp.com/' }];
}

export default function Index() {
  return (
    <>
      <Nav />
      <Hero />
      <DemoSection />
      <BuiltFor />
      <Pricing />
      <FinalCta />
    </>
  );
}
